import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { fetchApi } from '../../services/apiService'

const FuelStationsAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], isFormikFormField = false, showFormError = false,
        isCompulsory = false, singleSelect = true, label = "FuelStation", searchPlaceholder = "Search By FuelStation Name",
        noDataLabel = "No FuelStation Found", width = "100%", listWidth = width,
        ...rest } = props;
    let FuelStationOptions = [];
    if (allOption) {
        FuelStationOptions.push({ fuelStationName: 'All FuelStations', fuelStationId: 0 });
    }
    let initialProps = {
        ...rest,
        labelKey: 'fuelStationName',
        primaryKey: 'fuelStationId',
        options: FuelStationOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        isCompulsory,
        singleSelect,
        label,
        searchPlaceholder,
        noDataLabel,
        width,
        listWidth,
        dataLoaded: selectedValues.length > 0 ? false : true
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getFuelStationsOptions = async () => {
            const getFuelStationParams = { getFullDetails: "Y" };
            const response = await fetchApi('masters/getFuelStations', getFuelStationParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption) {
                    newOptions.push({ fuelStationName: 'All Fuel Stations', fuelStationId: 0 });
                }
                if (response.data.fuelStations.length > 0) {
                    newOptions = newOptions.concat(response.data.fuelStations);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((c) => selectedValues.indexOf(c.fuelStationId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getFuelStationsOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default FuelStationsAutocomplete;